import { styled } from 'styled-components';

// The close button itself
export const Button = styled.button`
  font-size: 1.5rem;
`;
